interface TermsUseTextProps {
    system?: string;
}

const TermsUseText = ({ system = "Paçoca Oficial" } : TermsUseTextProps) =>{
    return (
        <div style={{textAlign: "justify"}}>
            <p>Última atualização: 04/11/2026</p>

            <h5>Aceitação dos Termos</h5>
            <p>Ao utilizar a {system}, você concorda com estes Termos de Uso e com nossa Política de Privacidade. Caso não concorde com alguma das cláusulas, por favor, não utilize nossa plataforma.</p>

            <h5>Modificações nos Termos</h5>
            <p>A {system} se reserva o direito de modificar ou atualizar estes Termos a qualquer momento. Recomendamos que você reveja periodicamente para estar ciente de quaisquer alterações.</p>

            <h5>Elegibilidade</h5>
            <p>Para utilizar a {system}, o usuário deve ter pelo menos 13 anos de idade. Usuários menores de idade devem obter consentimento dos pais ou responsáveis.</p>

            <h5>Conta de Usuário</h5>
            <p>Para acessar certos recursos da {system}, você deverá criar uma conta, fornecendo informações verdadeiras, precisas e atualizadas. Você é responsável por manter a segurança de sua conta e senha.</p>

            <h5>Selos, cargos e critérios de atividade</h5>
            <p>
                Alguns selos, cargos, permissões e benefícios da {system} dependem do cumprimento contínuo dos critérios
                divulgados para cada recurso e podem ser revisados, concedidos, suspensos ou removidos pela plataforma.
                O uso indevido, informações falsas, fraude, violação destes Termos ou das Diretrizes, ou a perda dos
                requisitos aplicáveis pode resultar na remoção, sem que isso gere direito a indenização.
            </p>
            <p>
                Os selos vinculados à atividade podem ser atualizados automaticamente. Atualmente, o selo de atividade
                é concedido a contas com mais de cinco publicações nas últimas 24 horas e pode ser removido quando não
                houver publicação nesse mesmo período. Cargos, permissões e selos exclusivos da equipe podem ser
                removidos após 14 dias consecutivos sem abertura da plataforma. Outros selos podem possuir critérios,
                prazos ou regras próprios, informados na área ou no fluxo de solicitação correspondente.
            </p>

            <h5>Conduta do Usuário</h5>
            <p>Você concorda em não:</p>
            <ul>
                <li>Publicar conteúdo ofensivo, abusivo, difamatório, ou que viole direitos de terceiros.</li>
                <li>Envolver-se em atividades ilegais, fraudulentas, ou que possam causar danos à {system} ou a outros usuários.</li>
                <li>Utilizar a plataforma para distribuir spam, vírus ou outros materiais prejudiciais.</li>
                <li>Impedir ou interferir no funcionamento da plataforma.</li>
            </ul>

            <h5>Direitos de Propriedade Intelectual</h5>
            <p>Todos os direitos autorais, marcas registradas, e outros direitos de propriedade intelectual sobre o conteúdo disponibilizado na {system} pertencem à plataforma ou aos respectivos proprietários de conteúdo.</p>

            <h5>Conteúdo do Usuário</h5>
            <p>Você mantém todos os direitos sobre o conteúdo que publica na {system}. No entanto, ao publicar, você concede à {system} uma licença não exclusiva, mundial e gratuita para usar, modificar, exibir e distribuir seu conteúdo.</p>

            <h5>Privacidade e Dados</h5>
            <p>A coleta e uso de dados pessoais estão descritos em nossa Política de Privacidade. Ao utilizar a plataforma, você concorda com esses termos.</p>

            <h5>Encerramento de Conta</h5>
            <p>A {system} se reserva o direito de suspender ou encerrar sua conta a qualquer momento, sem aviso prévio, caso você viole estes Termos.</p>

            <h5>Limitação de Responsabilidade</h5>
            <p>A {system} não se responsabiliza por qualquer perda ou dano resultante do uso da plataforma, incluindo, mas não se limitando a, perda de dados ou lucros cessantes.</p>

            <h5>Disposições Finais</h5>
            <p>Estes Termos constituem o acordo integral entre o usuário e a {system}, substituindo quaisquer acordos anteriores. Quaisquer disputas serão resolvidas sob as leis da [jurisdição aplicável].</p>

            <h5>Trabalho Voluntário</h5>
            <p>Todo colaborador, moderador e desenvolvedor da {system} concorda que está realizando um serviço voluntário, sem expectativa de monetização ou pagamento de qualquer natureza.</p>

            <h5>Direitos dos Usuários</h5>
            <p>Os direitos, escolhas e bases legais relacionados a dados pessoais estão descritos na Política de Privacidade. O uso do serviço não transforma todos os tratamentos em consentimento: alguns são necessários para fornecer a plataforma, cumprir a lei, manter a segurança ou exercer direitos.</p>

            <h5>Fase Beta de Desenvolvimento</h5>
            <p>A {system} está em fase beta de desenvolvimento, o que pode acarretar falhas, bugs e instabilidade na plataforma. O uso é por conta e risco do usuário, que reconhece e aceita estas condições ao utilizar o serviço.</p>

            <h5>Base Legal do Tratamento de Dados</h5>
            <p>Os dados pessoais são tratados com base no consentimento do usuário, na execução de contratos, no cumprimento de obrigações legais e outras bases permitidas pela LGPD. Cada tratamento é justificado conforme essas bases legais.</p>

            <h5>Cookies, armazenamento e anúncios</h5>
            <p>A {system} usa cookies e armazenamento local ou de sessão para autenticação, preferências, segurança, métricas e anúncios. A publicidade pode envolver fornecedores terceiros e pode ser personalizada conforme suas configurações. Os detalhes estão na Política de Privacidade.</p>

            <h5>Canal de privacidade</h5>
            <p>Para dúvidas e solicitações sobre privacidade, utilize o e-mail <a href="mailto:pacocaredesocial@gmail.com">pacocaredesocial@gmail.com</a>. Quando aplicável, o canal também encaminhará solicitações ao responsável pelo tratamento.</p>

            <h5>Transferência Internacional de Dados</h5>
            <p>Alguns fornecedores podem processar dados fora do Brasil. Os detalhes e as salvaguardas aplicáveis estão descritos na Política de Privacidade.</p>

            <h5>Medidas de Segurança</h5>
            <p>A {system} busca aplicar medidas técnicas e administrativas compatíveis com os riscos para proteger os dados. Nenhum serviço conectado à internet é absolutamente seguro.</p>

            <h5>Atualizações e Notificações</h5>
            <p>Atualizações relevantes nos Termos de Uso ou na Política de Privacidade poderão ser comunicadas por e-mail, aviso ou diretamente na plataforma, conforme a natureza da alteração.</p>

            <hr className="mt-3 mb-3"/>
            <h2>Política de Privacidade</h2>
            <p>
                A coleta, o uso, o compartilhamento, os anúncios, a retenção, a análise e a exclusão de dados estão
                descritos na nossa <a href="/politica-privacidade">Política de Privacidade</a>. Ela explica também que
                a publicidade pode envolver fornecedores como o Google AdSense e que conteúdo pode ser removido após
                análise automatizada ou humana, conforme as regras, a segurança e a legislação aplicáveis.
            </p>
        </div>
    )
}

export default TermsUseText;